




































import { Component, Vue } from 'vue-property-decorator';
import SectionTuileNav from '@/components/shared/SectionTuileAnimNav.vue'
import SectionTuileDouble from '@/components/shared/SectionTuileDouble.vue'
import { ITuileNav } from '@/models/ui/ITuileNav';
import { EnVisio, ADomicile } from '@/router/pages';
import { ConvertToTuileNav } from '@/models/alo/AloActivity';

@Component({
  name:"Enfants",
  components: { SectionTuileNav,SectionTuileDouble},
})
export default class Enfants extends Vue {
  private arianeItems = [
        {
          text: 'Accueil',
          disabled: false,
          to: {name:'Home'},    
          exact:true      
        },
        {
          text: 'Activités enfants',
          disabled: true
        }
      ]

  get coursItems(){
    return this.$store.myGetters.activityList.filter(a => a.acyEnfant).map(a => ConvertToTuileNav(a))        
  }

  created(){        
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  private domicileItems = [
    EnVisio,
    ADomicile
  ]
}
